const strings = {
  brand: "Connecty.Me"
};

export default strings;
